<div class="html" [innerHTML]="safeHTML">
</div>